/**
 * Machine-readable error codes for the branches API. The shared problem
 * details filter keeps only `detail`, so the server puts the code string in
 * the exception message and clients match on it.
 */ /**
 * HTTP 409: the `version` sent on a `PUT` or a status `PATCH` no longer
 * matches the stored row. The client refetches the list.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BRANCH_LAST_ACTIVE () {
        return BRANCH_LAST_ACTIVE;
    },
    get BRANCH_NAME_TAKEN () {
        return BRANCH_NAME_TAKEN;
    },
    get BRANCH_VERSION_CONFLICT () {
        return BRANCH_VERSION_CONFLICT;
    }
});
const BRANCH_VERSION_CONFLICT = 'BRANCH_VERSION_CONFLICT';
const BRANCH_NAME_TAKEN = 'BRANCH_NAME_TAKEN';
const BRANCH_LAST_ACTIVE = 'BRANCH_LAST_ACTIVE';
